import React from 'react';
import { styles } from './styles';

export const Badge = ({style, size, label}) => {
  return (
    <div style={styles.badge(size, style)}>
      {label}
    </div>
  );
};



/** WEBPACK FOOTER **
 ** ./components/shared/Badge.js
 **/